import { TOKEN_KEY } from './cookie'

export const isPhone = (phone: string) => {
  const reg = /^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/
  return reg.test(phone)
}

export const authToken = () => {
  const accountInfo = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}')
  // eslint-disable-next-line no-bitwise
  console.log(accountInfo?.expired_at, ~~(+new Date() / 1000))
  // eslint-disable-next-line no-bitwise
  return accountInfo?.expired_at > ~~(+new Date() / 1000)
}

export const authBindMobile = () => {
  const accountInfo = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}')
  // eslint-disable-next-line no-bitwise
  return !!accountInfo?.account_info?.phone
}

export const authBindGameAccount = () => {
  const accountInfo = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}')
  // eslint-disable-next-line no-bitwise
  return !!accountInfo?.account_info?.role_id
}

export const getUserInfoByKey = (key: string) => {
  const accountInfo = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}')
  // eslint-disable-next-line no-bitwise
  return accountInfo?.account_info?.[key]
}

export function formatNumber(value: number | string, toFixed = 0) {
  if (value === null || value === undefined) return '-'
  if (value === 0) {
    return parseFloat(`${value}`).toFixed(toFixed)
  }
  let num
  if (value !== '') {
    num = ''
    value += ''
    value = parseFloat((value as string).replace(/,/g, '')).toFixed(toFixed)
    if (value.indexOf('.') === -1) {
      num = value.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => {
        return `${s},`
      })
    } else {
      num = value.replace(/(\d)(?=(\d{3})+\.)/g, (s) => {
        return `${s},`
      })
    }
  } else {
    num = ''
  }
  return num
}

const PHONE_NOT = '請輸入手機號碼'
const PHONE_FORMAT = '請輸入正確的手機號碼'
export function validateMobile(calling_code: number, phone: string) {
  // { label: '台灣', value: 886 },
  // { label: '香港', value: 852 },
  // { label: '澳門', value: 853 },
  // { label: '其他', value: 86 },
  if (!phone) return PHONE_NOT
  switch (calling_code) {
    case 886:
      return phone.length === 9 || phone.length === 10 ? '' : PHONE_FORMAT
    case 852:
    case 853:
      return phone.length === 9 || phone.length === 10 ? '' : PHONE_FORMAT
    case 86:
      return phone.length === 11 ? '' : PHONE_FORMAT
    default:
      return ''
  }
}

export function isType(params: any, typeStr: string) {
  return (
    Object.prototype.toString.call(params).slice(8, -1).toLocaleUpperCase() ===
    typeStr.toLocaleUpperCase()
  )
}
export function isPlainObject(params: any) {
  return Object.prototype.toString.call(params) === '[object Object]'
}

function encode(val: string): string {
  return encodeURIComponent(val)
    .replace(/%40/g, '@')
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']')
}

export function buildURL(url: string, params?: any) {
  if (!params) {
    return url
  }

  const parts: string[] = []
  // const parts: Array<string> = []
  Object.keys(params).forEach((key) => {
    const val = params[key]
    if (val === null || val === undefined) {
      return
    }
    let values = []
    if (Array.isArray(val)) {
      values = val
      key += '[]'
    } else {
      values = [val]
    }

    values.forEach((val) => {
      if (isType(val, 'Date')) {
        // 这里 typescript 不能推断其为Date类型 所以需要使用类型谓词
        // val = val.toI
        val = val.toISOString
      } else if (isPlainObject(val)) {
        val = JSON.stringify(val)
      }

      parts.push(`${encode(key)}=${encode(val)}`)
    })
  })

  const serializedParams = parts.join('&')
  if (serializedParams) {
    // 去掉 hash
    const markIndex = url.indexOf('#')
    if (markIndex !== -1) {
      url = url.slice(0, markIndex)
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams
  }

  return url
}
